import { render } from "./DetalharTransferenciaConta.vue?vue&type=template&id=4793befe&scoped=true"
import script from "./DetalharTransferenciaConta.vue?vue&type=script&lang=js"
export * from "./DetalharTransferenciaConta.vue?vue&type=script&lang=js"

import "./DetalharTransferenciaConta.vue?vue&type=style&index=0&id=4793befe&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4793befe"]])

export default __exports__